// home.js
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Fetch from '../../../../../core/util/core/Fetch';
import config from '../../../../config/config';
import Toast from '../../../../../core/components/core/Util/Toast/Toast';
import CustomList from '../Util/List/CustomList/CustomList'
import CustomListContainer from '../Util/List/CustomList/CustomListContainer'
import { loadData } from '../Util/List/CustomList/loadData';

import '../home/Home.css';

const Documentation = () => {
  const sessionSelector = useSelector((state) => { return state.core.session });
  const friendly_url = sessionSelector.pdc_project_friendly_url;

  const paths = {
    endpoint: config.endpoints.backend + 'portal/getallbankinghistories',
    endpointGetAllBankAccounts: config.endpoints.backend + 'portal/getallbankaccounts'
  }

  const filters = {
    validateOnChange: true,
    showGoBackButton: false,
    showSubmitButton: false,
    handleSubmit: loadData,
    fields: [
      {
        name: 'pdc_bank_account_id',
        type: 'select',
        label: 'Conta',
        options: [],
        optionsEndpoint: {
          endpoint: paths.endpointGetAllBankAccounts,
          label: 'accountid',
          value: 'id',
          params: {
            filter: {
              friendly_url
            }
          }
        },
        validations: {
          required: false
        },
        columnSize: 3
      },
      {
        name: 'month',
        type: 'select',
        label: 'Mês',
        options: [{
          value: '01',
          label: 'Janeiro'
        },
        {
          value: '02',
          label: 'Fevereiro'
        },
        {
          value: '03',
          label: 'Março'
        },
        {
          value: '04',
          label: 'Abril'
        },
        {
          value: '05',
          label: 'Maio'
        },
        {
          value: '06',
          label: 'Junho'
        },
        {
          value: '07',
          label: 'Julho'
        },
        {
          value: '08',
          label: 'Agosto'
        },
        {
          value: '09',
          label: 'Setembro'
        },
        {
          value: '10',
          label: 'Outubro'
        },
        {
          value: '11',
          label: 'Novembro'
        },
        {
          value: '12',
          label: 'Dezembro'
        }],
        validations: {
          required: false
        },
        columnSize: 2
      },
      {
        name: 'year',
        type: 'year',
        selectable: true,
        label: 'Ano',
        validations: {
          required: false
        },
        columnSize: 2
      },
      {
        name: 'filtro',
        type: 'submit',
        label: 'Pesquisar',
        columnSize: 1
      },
      {
        name: 'reset',
        type: 'reset',
        label: 'Limpar',
        columnSize: 2
      },
    ]
  }

  let list = {
    labelTitle: 'Histórico de Transações',
    labelTitleButtonAdd: 'Importar Extrato',
    fieldsShowOnDelete: ['trnamt'],
    showPrintButtons: true,
    showActionButton: false,
    filter: {
      friendly_url
    },
    formFilters: filters,
    columns: [
      {
        name: 'project_name',
        label: 'Projeto',
      },
      {
        name: 'bank',
        label: 'Banco',
        width: '15%'
      },
      {
        name: 'accountid',
        label: 'Conta',
        width: '10%'
      },
      {
        name: 'trnamt',
        label: 'Valor',
        width: '10%'
      },
      {
        name: 'memo',
        label: 'Descrição',
        width: '30%'
      },
      {
        name: 'dtposted',
        label: 'Data',
        width: '10%'
      },
    ]
  };

  return (
    <CustomListContainer
      canAdd={false}
      labelTitle={list.labelTitle}
      icon={list.icon}
      content={<CustomList list={{ ...list, ...paths }} />}
    />
  );
};

export default Documentation;
